import React, {Component} from "react";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import helpers from './../../networking/Helpers';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {Link, Redirect} from "react-router-dom";
import Map, { Marker, GeolocateControl } from 'react-map-gl';

const mapboxgl = require('mapbox-gl');
var location='';
mapboxgl.accessToken = 'pk.eyJ1Ijoic3JiMjMwNSIsImEiOiJja2tjZ2RmaWgwZ3hwMm5vYzdpMDJpMDJuIn0.7jUnhE7JBYdObO7MvqGnXQ';

class CheckinPopup extends Component {
    constructor(props) {
        super(props);
        this.timer = this.timer.bind(this);
        this.mapRef = React.createRef();
		    this.state = {
		      checkInStatus:true,
          checkin_with_time:false,
          user_id : '',
		      diff : '00:00',
		      timestampnote: '',
		      checkstatus:"",
		      chektext:'',
		      project:[],
		      material_list: [],
		      selected_material:'',
		      project_id:'',

          lng: 0,
          lat: 0,
          zoom: 12,
          positionStatus:true,
          isProjectField:false
		    };
        this.handleTimeNote = this.handleTimeNote.bind(this);
        this.showPosition = this.showPosition.bind(this);
        this.showError=this.showError.bind(this)
		}
    // ----- start google map code---------
	  displayTheMap = () => {
	    const   map = new mapboxgl.Map({
	      container: "mapContainer",
	      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
	      center: [-74.5, 40], // starting position [lng, lat]
	      zoom: 9, // starting zoom
        projection: 'globe' // display the map as a 3D globe
    });
   
    //Add geolocate control to the map.
    var geolocate = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    })

    map.addControl(geolocate);
    map.on('load', function() {
      geolocate.trigger();
    });   
    
  };
  // ----- End google map code---------

  // --------------checkinout popup ------------
  componentDidMount(){
    var user_id = this.props.p_userid;
    var status= localStorage.getItem("status");
    var checkInStatus = localStorage.getItem("checkInStatus");
    var department_id=localStorage.getItem('department_id');
    let menu_permission= localStorage.getItem('menu_permission');
    let menulist=JSON.parse(menu_permission) || [];
    let menu_ary=[]
    if(menulist) {
    menulist.map(item => {
        menu_ary.push(item.integration_id);
      });
    }

    if(menu_ary.includes(6)){ // Project
      this.setState({isProjectField:true})
    }
    let timestamp_option = localStorage.getItem('timestamp_option');
    if(timestamp_option !== null){
    let timesoption=JSON.parse(timestamp_option);
      this.setState({
          checkin_with_time:(timesoption.checkin_with_time === 1) ? true : false
      });
    }
     this.setState({user_id:user_id,chektext:status})
      if(checkInStatus!==""){
        this.setState({checkInStatus: ( (localStorage.getItem("checkInStatus") === true) || (localStorage.getItem("checkInStatus") === 'true') ) ? true : false })
      }
      if(checkInStatus===null){
        localStorage.setItem("status","");
        this.setState({checkInStatus:true})
      }        
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition,this.showError,{maximumAge:60000, timeout:5000, enableHighAccuracy:true})
      } else {
        console.log("Geo Location not supported by browser");
      }

      this.lastTimestampDetail(user_id);   
     
      if(localStorage.getItem('checkin_with_project') === '1'){
        this.getProject(department_id);
      }
  }

  //function that retrieves the position
  showError(err) {
    console.log("err", err.code == 1)
    if (err.code == 1) {
      this.setState({positionStatus:false})
    }
  }
  showPosition(position) {
    this.setState({positionStatus:true})
    this.setState({lat:position.coords.latitude })
    this.setState({lng:position.coords.longitude})
    if(this.mapRef && this.mapRef.current) {
      this.mapRef.current.flyTo({
        center:[position.coords.longitude,position.coords.latitude]
      })
    }
    location = { longitude: position.coords.longitude, latitude: position.coords.latitude };
  }
  handleTimeNote(event) {
    this.setState({timestampnote: event.target.value});
  }

  lastTimestampDetail(userId){
      try {
        var timeStamp = helpers.getCurrentDateTime();    
        var formData=new FormData();
        formData.append("user_id",userId);
        formData.append("timeStamp",timeStamp);
        post(Constent.LASTTIMESTAMPDETAIL,formData).then(response=>{
            if(response.status===true){
              localStorage.setItem('checkin_projectid',"0"); 
              localStorage.setItem('checkin_projectname',''); 
              localStorage.setItem('meetDateTime',""); 
              this.setState({project:response.project_list});
                var status_code = response.status_code;
                if(status_code === 1){
                  localStorage.setItem('diff',""); 
                  localStorage.setItem("checkInStatus",true);
                  this.setState({checkInStatus:true, diff : "00:00"});
                }else{
                  // already checkin
                  var meet = response.data.meet_time;
                  var momentCurrentTime =  moment(timeStamp,"YYYY-MM-DD HH:mm:ss");
                  var momentMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss");
                  var ruleMeetTime = "";
                  var diff = '00:00';   
                  if(momentMeetTime > momentCurrentTime){
                     ruleMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss").format("HH:mm");
                     diff = '00:00';     
                  }else{
                    ruleMeetTime = "";
                    diff = moment.utc(moment(timeStamp,"YYYY-MM-DD HH:mm:ss").diff(moment(meet,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm") 
                  }
                  localStorage.setItem('diff',diff);
                  this.setState({diff:diff});
                  localStorage.setItem('ruleMeetTime',ruleMeetTime);  

                  var momentCustomMeetDateTime = moment(meet,"YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY - HH:mm");
                  localStorage.setItem("meetDateTime",momentCustomMeetDateTime);

                  if(response.data.project_id !== 0){
                    localStorage.setItem("status","project");
                  }else if(response.shift_id !== 0){
                    localStorage.setItem("status","shift_id");
                  }else{
                    localStorage.setItem("status","time");
                  }
                  localStorage.setItem('checkInStatus',false); 
                  this.setState({checkInStatus:false});
                  if(response.project_id !== 0){
                    localStorage.setItem('checkin_projectid',response.project_id); 
                    localStorage.setItem('checkin_projectname',response.project_name); 
                  }
                }
            }else{
              localStorage.setItem("status","");
              localStorage.setItem('checkInStatus',true); 
              this.setState({checkInStatus:true});
            }
        })
      } catch(e) {
        console.log(e);
      }  
    }

   getProject(id){
    var formData=new FormData();
    formData.append("project_status","active");
    formData.append("department_id",id);
    formData.append("user_id",this.props.p_userid);

    if(JSON.parse(localStorage.getItem('user_data')).user_type === 'user'){
      var api = Constent.GETPROJECT;
    }else{
      api = Constent.GETALLPROJECT;
    }

    post(api,formData).then(response =>{
        if(response.status===1){
          this.setState({project:response.data,
            company_list:response.company,
          })
        }
    })
  }

    checkInOut(chekstatus){
      // if(this.state.positionStatus){
        var timeStamp= helpers.getCurrentDateTime();
        var formData=new FormData();
        formData.append("user_id",this.props.p_userid);
        formData.append("timeStamp",timeStamp);
        formData.append("currentStatus",localStorage.getItem('checkInStatus'));
        formData.append("deviceType","mobile");
        formData.append("timeStampNote",this.state.timestampnote);
        formData.append("project_id",this.state.project_id);
        formData.append("material_id",this.state.selected_material);
        formData.append("greater_14","");
        formData.append("terminal_id","");
        formData.append("shift_id","");
        formData.append("message_id","");
        formData.append("latitude", this.state.lat);
    formData.append("longitude", this.state.lng);
        post(Constent.CHECKINOUT,formData).then(response=>{
          if(response.status===1){
            if(response.msg.indexOf("out")!== -1){  
              this.setState({checkInStatus:true,chektext:''})
              localStorage.setItem("status","");
              localStorage.setItem('diff',"");
              this.setState({diff:'00:00'});
              localStorage.setItem('checkInStatus',true);
              Alert.success({title: response.msg});
              this.props.setCheckInStatus(true);
          
              var user_id=this.props.p_userid;
              this.lastTimestampDetail(user_id);

            }else{
              Alert.success({title: response.msg});
              this.setState({checkInStatus:false})
              localStorage.setItem('diff',"00:00");
              this.setState({diff:'00:00'});
              localStorage.setItem('checkInStatus',false);

              
              this.props.setCheckInStatus(false);
            }              
          //  this.props.handler();
          }
          this.setState({timestampnote:'',project_id:'',selected_material:''});
        })
      // }else{
      //   Alert.error({ title: "GPS not enabled" })
      // }
       
      }
    
    checkInOutProject(chekstatus){
           var timeStamp= helpers.getCurrentDateTime();
          var formData=new FormData();
          formData.append("user_id", this.props.p_userid);
          formData.append("timeStamp",timeStamp);
          formData.append("timeStampNote",this.state.timestampnote);
          formData.append("project_id", (this.state.project_id !== " ") ? this.state.project_id : localStorage.getItem('checkin_projectid'));
          formData.append("material_id",this.state.selected_material);
          
          post(Constent.CHECKINOUTPROJECT,formData).then(response=>{
            if(response.status===1){
               var user_id= this.props.p_userid;
              this.lastTimestampDetail(user_id);
               Alert.success({title: response.msg});
              this.setState({timestampnote:'',project_id:'',selected_material:''});
            //  this.props.handler();
            }else{
            	Alert.error({title: response.msg});
            }
          })
      } 

 
    handleChangeProject = name => event => {
      this.setState({ [name]: event.target.value });
      this.getProjectActivity(event.target.value);
    };
    getProjectActivity(project_id){
      var formData=new FormData();
      formData.append("project_id",project_id);
      formData.append("department_id",localStorage.getItem('department_id'));
      post(Constent.GETPROJECTACTIVITY,formData).then(response =>{
          if(response.status===1){
            this.setState({material_list:response.data.materials})
          }
      })
    }

    handleChangeMaterial(event) {
      this.setState({selected_material:event.target.value});
    }

    timer(){
      var user_id= this.props.p_userid;
      this.lastTimestampDetail(user_id);
    }
    render() {
      const { t } = this.props;
    		return (
          <div>
          { (localStorage.getItem('user_type') !== 'department') && (this.state.checkin_with_time) ?
          <Link className={ (this.state.checkInStatus === false) ? 'btn-warning punchclock-bottom' : 'btn-success punchclock-bottom'} to={'#'} data-toggle="modal" data-target="#popup-checkin-modal">
              
            { (this.state.checkInStatus === false) ? <span className="blink">{this.state.diff}</span>: <i className="fa fa-clock-o" aria-hidden="true"></i>}<br></br>
            { (this.state.checkInStatus === false) ? 'STOP' : 'START'}
          </Link>
          : '' }
          <div id="popup-checkin-modal" className="modal modal-top fade">
              <div className="modal-dialog" role="document">
                  <div className="modal-content">
                      <div className="modal-body" style={{maxHeight: '85vh'}}>
                         <div className="modal-close" data-dismiss="modal">
                              <i className="la la-times" />
                          </div>
                          <div className="action-sheet-content">
                              <form action="">
                                <div className="dashboard-punchclock center">
                                    <span className="time blink">{this.state.diff}</span>
                                    <Link className={ ((localStorage.getItem("checkInStatus") === true) || (localStorage.getItem("checkInStatus") === 'true')) ? 'btn btn-success punch-in center' : 'btn btn-warning punch-in center'} to={'#'} data-dismiss="modal" 
                                      onClick={()=>{
                                          var status=localStorage.getItem("status");
                                          if(status===""){
                                            localStorage.setItem("status",this.props.checkinoutScreen)
                                            this.checkInOut(this.props.checkinoutScreen)
                                          }else{
                                            this.checkInOut(this.props.checkinoutScreen)
                                          }
                                        }
                                      } >
                                          { ((localStorage.getItem("checkInStatus") === true) || (localStorage.getItem("checkInStatus") === 'true') || this.state.checkInStatus == true) ? 'START' : 'STOP' }
                                      </Link>
                                </div>
                               
                                <div className="text-center"><small>{ localStorage.getItem('ruleMeetTime') !== "" ? t('lang.timestamp_sc_your_time_will_begin_at') +' '+ localStorage.getItem('ruleMeetTime') : '' }</small></div>


                                <div className="form-group">
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control form-control-lg" placeholder={t('lang.timestamp_sc_note')} value={this.state.timestampnote} onChange={this.handleTimeNote} />
                                    </div>
                                </div>
                            { ((localStorage.getItem("checkInStatus") === true) || (localStorage.getItem("checkInStatus") === 'true')) ?     
                                <>
                                {
                                  this.state.isProjectField ?
                                  <>
                                  <div className="form-group ">
                                  <select className="form-control custom-select" id="account1"
                                  onChange={this.handleChangeProject('project_id')}>
                                      <option>{t('lang.timestamp_sc_choose_your_project')}</option>
                                      {this.state.project.map(({ project_id, project_code,project_name,project_start_date,project_end_date,show_more_option,is_unlimited,note,index}) => (
                                      <option value={project_id} key={project_id}>{project_name}</option>
                                      ))}
                                  </select>
                              </div>
                              <div className="form-group">
                                  <select className="form-control custom-select" id="account2">
                                      <option>{t('lang.timestamp_sc_task_of_project')}</option>
                                      {this.state.material_list.map(option => (
                                      <option key={option.id} value={option.id}>{option.material_name}</option>
                                      ))}
                                  </select>
                              </div>
                              </>
                                  :
                                  ""
                                }
                               
                                </>
                              : ''}    
                                  
                                <div className="form-group">
                                  {!this.state.positionStatus && 
                                    <label style={{color: 'white', backgroundColor: '#ff0000ad', padding: '5px'}}>{t('lang.timestamp_sc_geo_location_disabled')}</label>
                                  }
                                    <div className="input-wrapper">
                                     <div   className='mapContainer' >
                                     <Map
                          ref={this.mapRef}
                            mapboxAccessToken='pk.eyJ1Ijoic3JiMjMwNSIsImEiOiJja2tjZ2RmaWgwZ3hwMm5vYzdpMDJpMDJuIn0.7jUnhE7JBYdObO7MvqGnXQ'
                            mapStyle='mapbox://styles/mapbox/streets-v11'
                            height="100vh"
                            projection="globe"
                            initialViewState={{
                              longitude: this.state.lng,
                              latitude: this.state.lat,
                              zoom: 9
                            }}
                            >
                            <Marker
                            longitude= {this.state.lng}
                            latitude= {this.state.lat}
                             />
                             <GeolocateControl positionOptions={{ 
                               enableHighAccuracy: true }}
                                trackUserLocation={true}
                                onGeolocate={(e)=>{this.setState({lat:e.coords.latitude,lng:e.coords.longitude})}}
       
         />
                          </Map>
                        
                                       </div>
                                    </div>
                                </div>
                              </form>
                                  
                              
                          </div>
                      </div>
                  </div>
              </div>
        </div> 
      </div> 
	    )}
  	
}

export default withTranslation('common')(CheckinPopup);